import { render, staticRenderFns } from "./BizTaskRejectModule.vue?vue&type=template&id=891a7afe&scoped=true&"
import script from "./BizTaskRejectModule.vue?vue&type=script&lang=js&"
export * from "./BizTaskRejectModule.vue?vue&type=script&lang=js&"
import style0 from "./BizTaskRejectModule.vue?vue&type=style&index=0&id=891a7afe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "891a7afe",
  null
  
)

export default component.exports